import React from "react";
import "./App.css";

function App() {
  return (
    <div className="container mx-auto min-h-screen bg-neutral-900">
      <div className="relative">
        <img
          className="h-[170px] w-full object-cover"
          src="/store.jpg"
          alt=""
        />
        <div className="bg-gradient-to-t from-neutral-900 to-transparent h-[170px] absolute top-0 w-full"></div>
      </div>
      <div className="mt-[-75px]">
        <img
          className="w-[100px] rounded-full z-10 h-[100px] mx-auto border-2 border-yellow-500 relative"
          src="/logo.png"
          alt=""
        />
      </div>
      <div className="rounded-lg p-2 mt-3 mb-2">
        <h2 className="text-2xl font-bold text-center text-white font-morabba">
          اُورگـــیــــم
        </h2>
        <p className="text-center font-iranyekanx text-white text-xs mt-4">
          بهترین محصولات گیمینگ را از ما بخواهید
        </p>
      </div>
      <div className="p-2 mt-3">
        <div className="grid grid-cols-2 gap-2">
          <a
            href="tel:+982186091052"
            className="h-[50px] bg-yellow-500 rounded-md hover:bg-yellow-400 flex items-center"
          >
            <i className="fa-solid fa-phone-flip text-xl pr-5"></i>
            <span className="font-iranyekanx text-md font-bold ss02 grow text-center">
              تماس بگیرید
            </span>
          </a>
          <a
            href="https://ovgame.ir"
            className="h-[50px] bg-yellow-500 rounded-md hover:bg-yellow-400 flex items-center"
          >
            <i className="fa-solid fa-link text-xl pr-5"></i>
            <span className="font-iranyekanx text-md font-bold ss02 grow text-center">
              وب سایت
            </span>
          </a>
        </div>
        <div className="px-20 md:px-40 lg:px-40 mb-4 py-5 mt-5">
          <div className="border-t-2 relative flex justify-center">
            <span className="text-sm font-bold text-white font-iranyekanx bg-neutral-900 px-5 absolute mt-[-13px]">
              آدرس شعبات
            </span>
          </div>
        </div>
        <div className="bg-neutral-950 shadow-lg p-2 rounded-md font-iranyekanx">
          <div className="relative">
            <img
              className="rounded-md h-[100px] w-full object-cover"
              src="/setin.jpg"
              alt=""
            ></img>
            <div className="bg-gradient-to-t from-neutral-950 to-transparent h-[100px] absolute top-0 w-full"></div>
            <p className="text-white text-xl font-bold text-center pb-2 mb-8 mt-[-40px] z-10 relative">
              فروشگاه پلاتین
            </p>
          </div>
          <div className="rounded-md bg-neutral-900 p-2 pt-4">
            <div className="flex mb-2  px-3">
              <i className="fa-regular fa-location-dot text-white ml-2"></i>
              <p className="text-white text-sm font-semibold">آدرس</p>
            </div>
            <div className="p-2  ">
              <p className="text-white font-thin text-sm px-3">
                تهران شهرک غرب بلوار فرحزادی نبش سیما ایران مجتمع تجاری پلاتین
                طبقه دوم واحد ۲۵۴
              </p>
            </div>
            <div className="flex px-3 my-3">
              <i className="fa-regular fa-location-dot text-white ml-2"></i>
              <p className="text-white text-sm font-semibold">ساعات کاری</p>
            </div>
            <div className="grid grid-cols-2 gap-2 mt-2">
              <div className="col-span-2 py-2 bg-neutral-950 rounded-md flex justify-center">
                <span className="text-white text-sm font-light">
                  شنبه تا ۵شنبه{" "}
                </span>
              </div>
              <div className="py-2 bg-neutral-950 rounded-md flex justify-center">
                <span className="text-white text-sm font-light">
                  از ساعت ۱۰:۰۰ صبح
                </span>
              </div>
              <div className="py-2 bg-neutral-950 rounded-md flex justify-center">
                <span className="text-white text-sm font-light">
                  الی ساعت ۲۰:۰۰ شب
                </span>
              </div>
              <div className="col-span-2 py-2 bg-neutral-950 rounded-md flex justify-center">
                <span className="text-white text-sm font-light">جمعه </span>
              </div>
              <div className="py-2 bg-neutral-950 rounded-md flex justify-center">
                <span className="text-white text-sm font-light">
                  از ساعت ۱۶:۰۰ عصر
                </span>
              </div>
              <div className="py-2 bg-neutral-950 rounded-md flex justify-center">
                <span className="text-white text-sm font-light">
                  الی ساعت ۲۰:۰۰ شب
                </span>
              </div>
            </div>
          </div>
          {/* <div className="mt-2 grid grid-cols-2 gap-2">
            <a
              href="https://waze.com/ul/htnke2ucde"
              className="flex bg-blue-600 rounded-md h-[40px] justify-center items-center hover:bg-blue-500"
            >
              <i className="fa-brands fa-waze text-white text-xl mr-4"></i>
              <p className="text-white text-sm font-semibold grow text-center">
                میسریاب ویز
              </p>
            </a>
            <a
              href="https://maps.app.goo.gl/Wfw9LApCRVxunuJq7"
              className="flex bg-green-600 rounded-md h-[40px] justify-center items-center hover:bg-green-500"
            >
              <i className="fa-regular fa-map text-white text-xl mr-4"></i>
              <p className="text-white text-sm font-semibold grow text-center">
                میسریاب گوگل مپ
              </p>
            </a>
          </div> */}
        </div>
        <div className="px-20 md:px-40 lg:px-40 mb-4 py-5 mt-5">
          <div className="border-t-2 relative flex justify-center">
            <span className="text-sm font-bold text-white font-iranyekanx bg-neutral-900 px-5 absolute mt-[-13px]">
              تلفن های تماس
            </span>
          </div>
        </div>
        <a href="tel:+982186091052">
          <div className="flex bg-neutral-950 h-[55px] rounded-md my-2 items-center px-6 justify-between font-iranyekanx text-white hover:bg-yellow-400 hover:text-black">
            <i className="fa-solid fa-phone-flip text-yellow-500 text-xl "></i>
            <span
              className=" grow text-center ss02 text-sm font-semibold"
              style={{ direction: "ltr" }}
            >
              <span className="font-bold ss02">( 021 )</span> - 86091052
            </span>
            <i className="fa-solid fa-chevron-left text-yellow-500 text-xl"></i>
          </div>
        </a>
        <a href="tel:+989212088216">
          <div className="flex bg-neutral-950 h-[55px] rounded-md my-2 items-center px-6 justify-between font-iranyekanx text-white hover:bg-yellow-400 hover:text-black">
            <i className="fa-solid fa-phone-flip text-yellow-500 text-xl "></i>
            <span
              className=" grow text-center ss02 text-sm font-semibold"
              style={{ direction: "ltr" }}
            >
              09212088216
            </span>
            <i className="fa-solid fa-chevron-left text-yellow-500 text-xl"></i>
          </div>
        </a>
      </div>
      <footer className="h-[50px] bg-neutral-950 flex items-center justify-center">
        <span className="text-center text-neutral-700 font-iranyekanx text-xs">
          تمامی حقوق مطعلق است به مجموعه اورگیم
        </span>
      </footer>
    </div>
  );
}

export default App;
